import VariantCharacterService from "@/services/variantCharacter.service.js";

export default class VariantCharacterUsecase {
  constructor () {
    this.VariantCharacterService = new VariantCharacterService();
  }

  async getVariantCharacter (options) {
    const res = await this.VariantCharacterService.get(options);
    return res;
  }

  async createVariantCharacter (options) {
    const res = await this.VariantCharacterService.create(options);
    return res;
  }

  async updateVariantCharacter (options) {
    const res = await this.VariantCharacterService.update(options);
    return res;
  }

  async deleteVariantCharacter (options) {
    const res = await this.VariantCharacterService.delete(options);
    return res;
  }
}
